<template>
  <div>
    <zj-layout-container>
      <zj-layout-header style="paddingTop:40px;">
         <el-date-picker
          v-model="chooseDate"
          type="date"
          format="yyyy-MM-dd"
          :clearable="false"
          placeholder="选择日期">
        </el-date-picker>
        <el-button size="medium" style="margin-left:30px" @click="search">查询</el-button>
      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div class="echart_1">
            <div>
              日客流走势同比
              <linechart
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="usePerData"
              ></linechart>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import {getYOYTrendByTimes} from '@/request/api';
import linechart from "@/views/echart/LineEcharts"
import moment from "moment";
export default {
  action: "PassengerFlowDay",
  controller: "UI",
  name: "PassengerFlowDay",
  components: {
    linechart
  },
  data(){
      return{
        chooseDate:new Date(),
        usePerData:{}
      }
  },
  mounted: function () {
    this.search();
  },
  methods:{
    search(){
      this.usePerData = {
        xData:[],
        yData:[{
          name:'',
          data:[]
        }]
      };
      let params = {
        "polityType": 3,
        "timeType": "hour",
        "timeValue": 24,
        "district": "652302",
        "districtCode": "652302",
        "startTime": this.getFormatTime(this.chooseDate),
        "endTime":  this.getFormatTime(this.chooseDate)
      }
      getYOYTrendByTimes(params).then(res=>{
        if(res.data){
          let dataList = res.data.dataList || {};
          var XData = [];
          for (let key in dataList) {
            XData = [];
            var yDataObj = {
              name :key,
              data:[]
            };
            dataList[key].map((item) => {
              const { dataTime, count } = item;
              XData.push(moment(dataTime).format("HH时"));
              yDataObj.data.push(count);
            });
            this.usePerData.yData.push(yDataObj);
          }
          this.usePerData.xData = XData;
        }
      })
    },

    getFormatTime(nS) {
      var date = new Date(nS); //获取一个时间对象
      let y = date.getFullYear(); // 获取完整的年份(4位,1970)
      let m =
          date.getMonth() + 1 < 10 ?
          "0" + (date.getMonth() + 1) :
          date.getMonth() + 1; // 获取月份(0-11,0代表1月,用的时候记得加上1)
      let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); // 获取日(1-31)
      return y + "-" + m + "-" + d;
    },
  },
}
</script>

<style scoped lang="scss">
.datelabel {
  border-right: 3px solid #2bc5ff;
  padding: 0 1rem;
}
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart_1,
.echart_2 {
  width: 100%;
  height: 48%;
}
.echart_1{
  margin-bottom: 15px;
}
.echart_2{
  margin-top: 15px;
}
.echart_1 > div,
.echart_2 > div {
  float: left;
  width: 50%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
}
</style>